import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { USER_ENGAGEMENT_ELEMENT_IDS } from 'lumen/models/seen-user-engagement-element';

export default class HotelBenchmarkInsightOnboardingRoute extends Route {
  @service declare userEngagement: Services['user-engagement'];

  afterModel(): void {
    this.userEngagement.markAsSeen(
      USER_ENGAGEMENT_ELEMENT_IDS.BENCHMARK_INSIGHT_LIGHT_ONBOARDING_MODAL,
    );
  }
}
